import { render, staticRenderFns } from "./PublicHolidayView.vue?vue&type=template&id=000b43c8&"
import script from "./PublicHolidayView.vue?vue&type=script&lang=js&"
export * from "./PublicHolidayView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports